import script from "./omsLogin.vue?vue&type=script&setup=true&lang=js"
export * from "./omsLogin.vue?vue&type=script&setup=true&lang=js"

import "./omsLogin.vue?vue&type=style&index=0&id=77642f7b&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/idaas_web_test/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77642f7b"]])

export default __exports__